import React from "react";
import {useTranslation} from "react-i18next";
//local
import ProjectsSelect from "components/selects/ProjectsSelect";

export const ContractsTableHead = ({projectId, projects, onChangeProject}) => {
  const {t} = useTranslation();

  const allProjectItem = {id: null, name: t("ALL_PROJECTS"), isArchived: false};

  return (
    <div className="requests-card_head">
      <div className="requests-card_head__icon __wrapper icon-col" />
      <div className="requests-card_head__number __wrapper number-col" />
      <div className="requests-card_head__name __wrapper name-col">{t("NAME")}</div>
      <div className="requests-card_head__column __wrapper company-col">
        {t("SUPPLIER")}
      </div>
      <div className="requests-card_head__column __wrapper date-col">{t("DATE")}</div>
      <div className="requests-card_head__column __wrapper project-col">
        {!!projects?.length && (
          <ProjectsSelect
            list={[allProjectItem, ...projects]}
            onChange={onChangeProject}
            noBorder
            needSearch
            defaultValue={projectId ?? allProjectItem.id}
          />
        )}
      </div>
    </div>
  );
};
